import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment-timezone';

@Pipe({
  standalone: false,
  name: 'rmsTzFormat'
})
export class RmsTzFormatPipe implements PipeTransform {

  transform(value: string, timezone: string, dateFormat: string): string {
    if (!value) {
      return value;
    }
    const formattedValue = moment.utc(value).tz(timezone).format(dateFormat);
    return formattedValue.toUpperCase() === 'INVALID DATE' ? value : formattedValue;
  }

}

